import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get  Timesheet 
export const getAttendance = createAsyncThunk("timesheet/getlist-timesheet", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/hrm/app/v1/getlist-timesheet`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching timesheet - ', error);
        throw error;
    }
})
